function noop() {}
const CLOST_SOCKET = 1e3;
const SOCKET_CODE = 1005;
export default function (url, opts) {
  opts = opts || {};

  const ms = opts.timeout || 3000;

  const $ = {};
  const self = this;

  let k;
  let ws;
  let timer;

  $.onmessage = opts.onmessage || noop;

  $.onclose = e => {
    e.code !== CLOST_SOCKET && e.code !== SOCKET_CODE && !ws.__closeRequested__ &&
      !timer && self.reconnect(e);
    (opts.onclose || noop)(e);
  };

  $.onerror = e => {
    (opts.onerror || noop)(e);
    if (e.code !== CLOST_SOCKET && e.code !== SOCKET_CODE && !ws.__closeRequested__ && !timer) {
      self.reconnect(e);
    }
  };

  $.onopen = e => {
    timer = null;
    (opts.onopen || noop)(e);
  };

  self.open = () => {
    ws = new WebSocket(url, opts.protocols);
    for (k in $) ws[k] = $[k]; // eslint-disable-line
  };

  self.reconnect = e => {
    if (__DEV__) console.log('reconnect starting websocket');
    timer = setTimeout(() => {
      timer = null;
      if (__DEV__) console.log('reconnect starting websocket timer cleaned');
      (opts.onreconnect || noop)(e);
      self.open();
    }, ms);
  };

  self.json = x => {
    ws.send(JSON.stringify(x));
  };

  self.send = x => {
    ws.send(x);
  };

  self.close = (x, y) => {
    ws.__closeRequested__ = true;
    ws.close(x, y);
    if (__DEV__) console.log(` websocket close manul ${url}`);
  };

  self.open(); // init

  return self;
}
